import React from 'react'
import { useState, useRef , useEffect} from 'react';
import { useForm } from "react-hook-form";
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Swal from "sweetalert2";
import { resetPassword } from '../../reducers/actions/auth';

const ResetPassword = () => {
  const [formResetPassword, setFormResetPassword] = useState({
    password: "",
    confirmPassword: "",
    email:"",
    token:""
  });
  const [successful, setSuccessful] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [email, setEmail] = useState('')
  const [token, setToken] = useState('')
  // Example usage


  useEffect(() => {
    const queryEmail = queryParams.get('email');
    const queryToken = queryParams.get('token');
    console.log('token', queryToken)
    setToken(queryToken)
    setEmail(queryEmail)
  }, []); // La matriz de dependencias vacía asegura que el efecto se ejecute solo una vez

  const {
    register,
    formState: { errors },
    watch,
    handleSubmit
  } = useForm();
  const password = useRef({});
  password.current = watch("password", "");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  /* const onSubmit = () => {}; */

  const handleInputChange = (e) => {
    setFormResetPassword({
      ...formResetPassword,
      [e.target.name]: e.target.value,
      email : email,
      token : token
    });
  };

  const onSubmit = (data)=>{
    setFormResetPassword({
      ...formResetPassword,
      password: data.password,
      email : email,
      token : token
    });

    try {
      Swal.fire({
        title: "Advertencia",
        text: "Quiere confirmar esta acción?",
        icon: "info",
        showDenyButton: true,
        denyButtonText: "No",
        confirmButtonText: "Si",
        confirmButtonColor: "#3085d6",
      }).then(response => {
        if (response.isConfirmed) {
          dispatch(resetPassword(formResetPassword))
            .then(() => {
              Swal.fire({
                icon: 'success',
                title: 'Exitoso!',
                text: 'Operación realizada correctamente.',
              }).then(r=>{
                navigate("/login");
              })
            })
            .catch(() => {
              setLoading(false);
            });
        }
        if (response.isDenied) {
          Swal.fire({
            title: "Cancelado",
            text: "Cancelaste el registro",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: "#3085d6",
          })
        }
      });
    } catch (error) {
      setMessage(error.response.data.message);
    }
  
  }

  return (
    <div className="Auth-form-container">
      <form onSubmit={handleSubmit(onSubmit)} className="Auth-form">
        <div className="Auth-form-content">
          <h3 className="Auth-form-title text-center">Reestablecer contraseña</h3>
          <h4 className="Auth-form-title text-center">{email}</h4>
          <div className="text-center"></div>
          <div className="form-group mt-3">
            <label>Contraseña nueva</label>
            <input
              name="password"
              type="password"
              className="form-control mt-1"
              placeholder="Ingrese contraseña"
              {...register("password", {
                required: "Debe ingresar una contraseña",
                minLength: {
                  value: 8,
                  message: "La contraseña debe tener al menos 8 caracteres",
                },
                pattern: {
                  value:
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,15}/,
                  message:
                    "La contraseña debe tener letras, numeros y uno o mas caracteres especiales",
                },
              })}
              onChange={handleInputChange}
            />
            {errors?.password && (
              <span className="danger">{errors.password.message}</span>
            )}
            <div id="passwordHelpBlock" className="form-text">
              Tu contraseña debe tener entre 8-20 caracteres, debe contener
              letras y numeros, y uno o mas caracteres especiales, no debe
              contener espacios.
            </div>
          </div>
          <div className="form-group mt-3">
            <label>Confirmar contraseña</label>
            <input
              name="confirmPassword"
              type="password"
              className="form-control mt-1"
              placeholder="Confirmar contraseña"
              {...register("confirmPassword", {
                validate: (value) =>
                  value === password.current ||
                  "Las contraseñas deben coincidir",
              })}
              onChange={handleInputChange}
            />
            {errors.confirmPassword && (
              <span className="danger">{errors.confirmPassword.message}</span>
            )}
            <div id="passwordHelpBlock" className="form-text">
              Las contraseñas deben coincidir.
            </div>
          </div>
          <div className="d-grid gap-2 mt-3">
            <button className="btn btn-success">Actualizar contraseña</button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default ResetPassword